import { render, staticRenderFns } from "./ReviewShow.vue?vue&type=template&id=88d24550&"
import script from "./ReviewShow.vue?vue&type=script&lang=js&"
export * from "./ReviewShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports